import {toast} from "react-toastify";
import ws from "../../sockets";
import {SocketType} from "../contants/Socket.Type";

var retry = 0;
export const fetchDisplayData = (dispaly) => (dispatch) => {
  dispatch(sendMsg(dispaly));
};
export const updateProductState = (dispaly, id) => (dispatch) => {
  dispatch(sendMsg(dispaly, SocketType.UPDATEPRODUCTSTATUS, id));
};
export const completeOrder = (dispaly, id) => (dispatch) => {
  dispatch(sendMsg(dispaly, SocketType.COMPLETEORDER, id));
};
export const fetchTable = () => (dispatch) => {
  dispatch(sendMsg("table"));
};
export const fetchNotificaiton = () => (dispatch) => {
  dispatch(sendMsg("notificaiton"));
};
export const cartUpdate = () => (dispatch) => {
  dispatch(sendMsg("cart"));
};
export const sendMsg =
  (type = false, action = false, message = false) =>
    (dispatch, getState) => {
      const user = getState().Auth;
      const data = JSON.stringify({
        Authorization: process.env.REACT_APP_API_KEY,
        Token: user.Token,
        UserID: user.userData.user_id,
        type: type,
        action: action,
        data: message,
      });
      ws.onopen = function () {
        console.log("ws open");
      };
      setTimeout(function () {
        if (ws.readyState === 1) {
          ws.send(data);
          retry = 0;
          dispatch(socketStatus(true));
        } else if (retry >= 5) {
          // window.location.reload();
          if (retry === 5) {
            dispatch(socketStatus(false));
            toast.error("⚠️ Websocket Error Reload Or Call Admin", {
              position: "top-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              // onClick: window.location.reload(),
              draggable: false,
              progress: false,
              draggableDirection: "y",
            });
          }
        } else {
          // console.log("Retry To Connect Socket " + retry);
          dispatch(sendMsg(type, action, message));
        }
        retry += 1;
      }, 1500 * retry); // wait 5 milisecond for the connection...
    };

export const recieveMsg = (response) => (dispatch, getstate) => {
  const Socket = getstate().Socket;
  if (response.type.toUpperCase() !== "") {
    Socket[response.type.toLowerCase()] = response.data;
    dispatch({
      type: SocketType.SET_SOCKET_DATA,
      payload: Socket,
    });
  } else {
    dispatch({
      type: SocketType.SET_SOCKET_DATA,
      payload: Socket,
    });
  }
};

export const socketStatus = (status) => (dispatch) => {
  dispatch({
    type: SocketType.SET_SOCKET_STATUS,
    payload: status,
  });
};
